import { Button, Tooltip } from "@material-ui/core"
import { useStyles } from "./button-modal-header-styles";
import { isEmpty } from 'lodash';

interface ButtonIconProps {
    icon: JSX.Element;
    tooltip: string;
    onClick: () => any;
}

export const ButtonModalHeader = (props: ButtonIconProps) => {
    const classes = useStyles();
    return (
        <>
            {!isEmpty(props.tooltip) &&
                (
                    <Tooltip arrow title={props.tooltip}>
                        <Button className={classes.button} onClick={props.onClick}>
                            {props.icon}
                        </Button>
                    </Tooltip>
                )}
            {isEmpty(props.tooltip) &&
                (
                    <Button className={classes.button} onClick={props.onClick}>
                        {props.icon}
                    </Button>
                )}
        </>
    )

}

